import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { trpc } from 'src/trpc';
import { AddOnForm } from './AddOnForm';
import { AddOnFormValues } from '@libs/schemas/src/add-on';
import { useToast } from 'src/components/useToast';

interface NewAddOnModalProps {
  onSuccess: () => void;
}

export const NewAddOnModal: React.FC<NewAddOnModalProps> = ({ onSuccess }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const createAddOnMutation = trpc.admin.addOn.create.useMutation();
  const { successToast, errorToast } = useToast();

  const handleCreateAddOn = async (values: AddOnFormValues) => {
    try {
      const priceInCents = Math.round(parseFloat(values.priceInCents) * 100);
      await createAddOnMutation.mutateAsync({
        ...values,
        priceInCents: priceInCents.toString(),
      });
      successToast({
        title: 'Add-on Created',
        description: 'The add-on was successfully created.',
      });
      setOpenDialog(false);
      onSuccess();
    } catch (error) {
      errorToast({
        title: 'Failed to Create Add-on',
        description: 'There was an error creating the add-on. Please try again.',
      });
    }
  };

  return (
    <AlertDialog open={openDialog} onOpenChange={setOpenDialog}>
      <AlertDialogTrigger asChild>
        <Button onClick={() => setOpenDialog(true)} className="text-white">
          New Add-on
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-left text-text-light mb-4">
            Create New Add-on
          </AlertDialogTitle>
          <AddOnForm
            onSubmit={handleCreateAddOn}
            onStateChange={({ isValid }) => setIsFormValid(isValid)}
          />
          <div className="flex flex-row justify-end gap-4 pt-4">
            <AlertDialogCancel className="mt-0 text-text-light">Cancel</AlertDialogCancel>
            <Button type="submit" form="add-on-form" className="text-white" disabled={!isFormValid}>
              Create Add-on
            </Button>
          </div>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
};
